import {
  CANCEL_SEARCH,
  FIND_IN_DOCUMENT,
  NAVIGATE_TO_OCCURRENCE,
  OPEN_SEARCH,
  SEARCH_FOUND,
  SEARCH_NOT_FOUND,
} from '../actions/types';

export default function find(state = {}, action = {}) {
  switch (action.type) {
    case FIND_IN_DOCUMENT:
      return { ...state, searchInProgress: true, ...action.payload };
    case NAVIGATE_TO_OCCURRENCE:
      return { ...state, ...action.payload };
    case OPEN_SEARCH:
      return {
        ...state, searchInProgress: false, matchCount: 0, isSearching: true,
      };
    case CANCEL_SEARCH:
      return {
        ...state, searchInProgress: false, matchCount: 0, isSearching: false, query: '', currentMatch: 0,
      };
    case SEARCH_FOUND:
      return { ...state, searchInProgress: false, ...action.payload };
    case SEARCH_NOT_FOUND:
      return {
        ...state, searchInProgress: false, matchCount: 0, currentMatch: 0,
      };
    default:
      return state;
  }
}
